import { initializeApp } from 'firebase/app';
import { getAnalytics, isSupported, logEvent } from 'firebase/analytics';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: 'AIzaSyCy-t6UVm8QCsHvdzHkLKsmZLTvnvN8ryo',
  authDomain: 'myfundz-website.firebaseapp.com',
  projectId: 'myfundz-website',
  storageBucket: 'myfundz-website.firebasestorage.app',
  messagingSenderId: '674003619892',
  appId: '1:674003619892:web:c7364e5382a0a80a8bfa61',
  measurementId: 'G-D1DQSXRCZW',
};

const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);

let analyticsInstance = null;
let pendingPage = null;

const sendPageTrackingEvents = ({ path, title }) => {
  if (!analyticsInstance || !path) {
    return;
  }

  const resolvedTitle = title || document.title || 'MyFundz';

  logEvent(analyticsInstance, 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: resolvedTitle,
  });

  logEvent(analyticsInstance, 'page_visit', {
    page_name: resolvedTitle,
    page_path: path,
  });
};

const flushPendingPageView = () => {
  if (!pendingPage) {
    return;
  }

  sendPageTrackingEvents(pendingPage);
  pendingPage = null;
};

if (typeof window !== 'undefined') {
  isSupported()
    .then((supported) => {
      if (!supported) {
        return;
      }

      analyticsInstance = getAnalytics(firebaseApp);
      flushPendingPageView();
    })
    .catch(() => {
      analyticsInstance = null;
    });
}

const trackPageView = ({ path, title }) => {
  if (!path || typeof window === 'undefined') {
    return;
  }

  if (!analyticsInstance) {
    pendingPage = { path, title };
    return;
  }

  sendPageTrackingEvents({ path, title });
};

export default firebaseApp;
export { firebaseConfig };
export { auth };
export { db };
export { trackPageView };